import React from 'react';
import './FilterBar.scss';
import FontAwesomeIcon from '../../../components/Icon';
import { ServiceRequestFilters } from '../CustomHooks/useServiceRequestFilters';

interface FilterBarProps {
  filters: ServiceRequestFilters;
  applyFilter: (key: string, data: any) => void;
  removeFilter: (key: string) => void;
}

const filterLabels: Record<string, string> = {
  PropertyId: 'Property',
  BuildingId: 'Building',
  LevelId: 'Level',
  UnitId: 'Units',
  TagIds: 'Tags',
  SubmittedFrom: 'Submitted From',
  SubmittedTo: 'Submitted To',
  ServiceType: 'Issue Type',
  ItemTypeId: 'Asset Type',
  AssignedToServiceProviderId: 'Service Provider',
};

const transformFilters = (filters: ServiceRequestFilters): string[] => {
  const { booleanFilters, Statuses, ...rest } = filters;

  const formattedFilters: string[] = Object.keys(rest).reduce(
    (acc: string[], key: string) => {
      if (rest[key]?.length) {
        acc.push(filterLabels[key]);
      }
      return acc;
    },
    []
  );

  formattedFilters.push(...(booleanFilters ?? []));
  return formattedFilters;
};

export const FilterBar = ({
  filters,
  applyFilter,
  removeFilter,
}: FilterBarProps) => {
  const handleRemoveFilter = (filter: string) => {
    if (filters.booleanFilters.includes(filter)) {
      applyFilter(
        'booleanFilters',
        filters.booleanFilters.filter(
          (booleanFilter: string) => booleanFilter !== filter
        )
      );
      return;
    }

    const key: string | undefined = Object.keys(filterLabels).find(
      (labelKey: string) => filterLabels[labelKey] === filter
    );

    if (key) {
      removeFilter(key);
    }
  };

  return (
    <div className="filter_bar">
      {transformFilters(filters).map((filter: string) => (
        <div
          key={filter}
          className="filter_bar__filter"
          onClick={() => handleRemoveFilter(filter)}
        >
          {filter}
          <FontAwesomeIcon size="small" glyph="trash" weight="solid" />
        </div>
      ))}
    </div>
  );
};
